<template>
<div class="step-title-button">
    {{step.title}}
</div>
</template>

<script>


export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        step: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },

    created() {

    }
}
</script>

<style scoped>  
.step-title-button {
    padding:5px 10px;
    border-radius:99px;
    display:inline-block;

}
.step-title-button:hover {
    background-color: rgba(0,0,0,0.06);
    /* box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.3); */
    cursor: pointer;
}
   
</style>




// WEBPACK FOOTER //
// FileUpload.vue?6b156fa6